export const SET_ON_BOARDING_SELLING_POINT_MUTATION = 'setOnBoardingSellingPointMutation';
export const RESET_ON_BOARDING_SELLING_POINT_MUTATION = 'resetOnBoardingSellingPointAction';

export const SET_ON_BOARDING_SELLING_POINT_LEGAL_REPRESENTS_MUTATION = 'setOnBoardingSellingPointLegalRepresentsMutation';

export const ADD_ON_BOARDING_SELLING_POINT_EMPTY_LEGAL_REPRESENT_MUTATION = 'addOnBoardingSellingPointEmptyLegalRepresentMutation';
export const REMOVE_ON_BOARDING_SELLING_POINT_LEGAL_REPRESENT_MUTATION = 'removeOnBoardingSellingPointLegalRepresentMutation';
